import React from 'react'
import {useSpring,animated} from 'react-spring'
import iith from '../img/IITLOGO.png'
import svc from '../img/svc.png'
import acbr from '../img/acbr.png'
import hrms from '../img/cbse.png'
import degree from '../img/degree2.png'
import styled from 'styled-components'
import { to } from "react-spring"
import Tilt from 'react-parallax-tilt';
import{Swiper, SwiperSlide} from "swiper/react"
import SwiperCore,{EffectCoverflow,Pagination} from "swiper/core"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import './Education.scss'

import  './Education.scss'
import Loader from 'react-loaders'



function Education() {
  
  return (
    <>
    <div className='container'>
       <div className="textZone" >
         
         <h1 className='text-[#63e8ff] font-bold text-2xl md:text-2xl mb-5 opacity-75'>
           Educational Qualifications
          </h1>
        
       
        
          

       </div>
      <div className='swiper-container'>
     <div className='flex justify-center'>
     <img src={degree} className="w-[20vw] h-[60vh] m-0"/>
     <Swiper className='w-[80vw]'
        effect={"coverflow"}
        grabCursor ={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
            rotate:50,
            stretch:0,
            depth:100,  
            modifier:6,
            slideShadows:true}}
        >
          
    
      <SwiperSlide >
     <Tilt className='flex items-center flex-col  justify-center w-auto h-auto bg-gray-600 rounded-md p-6 relative z-1   border-transparent  cursor-pointer shadow-cyan-200 shadow-md'>
      <div className='rounded-full shadow-md shadow-orange-100 h-[120px] w-[120px] items-center flex justify-center'><img src={iith} alt='iith' className='w-[100px] h-auto items-center p-3 justify center '/></div>
      <h1 className=' text-center font-thin my-2 text-orange-400 sm:text-md md: text-lg'>IIT Hyderabad</h1>
      <h2 className=' text-center my-1 font-bold text-sm text-gray-800'>Master of Technology(MTech)</h2>
      <h3 className=' text-center text-xs text-orange-200'>Biomedical Engineering</h3>
      <h4 className='text-center text-xs text-orange-200'>2021-2023</h4>

      <br/>
      <p className='text-center text-xs text-orange-200'>9.38 GPA</p>
      </Tilt>
      </SwiperSlide>
      <SwiperSlide>
     <Tilt className='flex items-center flex-col  justify-center w-auto  bg-gray-600 rounded-md p-6 relative z-1  border-transparent  cursor-pointer shadow-cyan-200 shadow-md mb-0'>
      <div className='rounded-full shadow-md shadow-orange-100 h-[120px] w-[120px] items-center flex justify-center'><img src={acbr} alt='iith' className='w-[100px] h-auto items-center p-3 justify center '/></div>
      <h1 className=' text-center font-thin my-2 text-orange-400 sm:text-md md: text-lg'>University Of Delhi</h1>
      <h2 className=' text-center my-1 font-bold text-sm text-gray-800'>Master of Science(MSc)</h2>
      <h3 className=' text-center text-xs text-orange-200'>Biomedical Sciences</h3>
      <h4 className='text-center text-xs text-orange-200'>2019-2021</h4>

      <br/>
      <p className='text-center text-xs text-orange-200'>8.265 GPA</p>
      </Tilt>
      </SwiperSlide>
      <SwiperSlide>
     <Tilt className='flex items-center flex-col  justify-center w-auto  bg-gray-600 rounded-md p-6 relative z-1  border-transparent  cursor-pointer shadow-cyan-200 shadow-md'>
      <div className='rounded-full shadow-md shadow-orange-100 h-[120px] w-[120px] items-center flex justify-center'><img src={svc} alt='iith' className='w-[100px] h-auto items-center p-3 justify center '/></div>
      <h1 className=' text-center font-thin my-2 text-orange-400 sm:text-md md: text-lg'>SVC,University Of Delhi</h1>
      <h2 className=' text-center my-1 font-bold text-sm text-gray-800'>Bachelor of Science(BSc)</h2>
      <h3 className=' text-center text-xs text-orange-200'>Biochemistry</h3>
      <h4 className='text-center text-xs text-orange-200'>2016-2019</h4>

      <br/>
      <p className='text-center text-xs text-orange-200'>8.324 GPA</p>
      </Tilt>
      </SwiperSlide>
      <SwiperSlide>
     <Tilt className='flex items-center flex-col  justify-center w-auto  bg-gray-600 rounded-md p-6 relative z-1   border-transparent  cursor-pointer shadow-cyan-200 shadow-md'>
      <div className='rounded-full shadow-md shadow-orange-100 h-[120px] w-[120px] items-center flex justify-center'><img src={hrms} alt='iith' className='w-[100px] h-auto items-center p-3 justify center '/></div>
      <h1 className=' text-center font-thin my-2 text-orange-400 sm:text-md md: text-lg'>Hansraj Model School</h1>
      <h2 className=' text-center my-1 font-bold text-sm text-gray-800'>12th Standard</h2>
      <h3 className=' text-center text-xs text-orange-200'>Medical with Maths</h3>
      <h4 className='text-center text-xs text-orange-200'>2015-2016</h4>

      <br/>
      <p className='text-center text-xs text-orange-200'>95.2%</p>
      </Tilt>
      </SwiperSlide>
      <SwiperSlide>
     <Tilt className='flex items-center flex-col  justify-center w-auto  bg-gray-600 rounded-md p-6 relative z-1   border-transparent  cursor-pointer shadow-cyan-200 shadow-md'>
      <div className='rounded-full shadow-md shadow-orange-100 h-[120px] w-[120px] items-center flex justify-center'><img src={hrms} alt='iith' className='w-[100px] h-auto items-center p-3 justify center '/></div>
      <h1 className=' text-center font-thin my-2 text-orange-400 sm:text-md md: text-lg'>Hansraj Model School</h1>
      <h2 className=' text-center my-1 font-bold text-sm text-gray-800'>10th Standard</h2>
      <h3 className=' text-center text-xs text-orange-200'></h3>
      <h4 className='text-center text-xs text-orange-200'>2013-2014</h4>

      <br/>
      <p className='text-center text-xs text-orange-200'>10 CGPA</p>
      </Tilt>
      </SwiperSlide>

      </Swiper>
      

</div>
</div>

</div>
<Loader type='ball-scale-multiple'/>
</>
  )
}

export default Education